import { MailDestinataire } from './mail-destinataire';

export class MailAction {
  public id: number;
  public mailId: number;
  public type?: string; // Type destinataire: DESTINATAIRE or SERVICE
  public statut?: string;
  public action?: string;
  public transmisDate?: string; // ($date-time)
  public echeance?: string; // ($date-time)
  public traiteLe?: string; // ($date-time)
  public message?: string;
  public reponse?: string;
  public fontBold?: string;
  public foreColor?: string;
  public serviceProprietaireId?: number;
  public serviceDestinataireId?: number;
  public destinataires?: MailDestinataire[];
}
